import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import { Outlet } from 'react-router';
import { getLocale } from '../../configuration/lang/langSlice';
import { isUserSessionExpired } from '../../configuration/login/loginSlice';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { AccountsSidebar } from '../components/tabs/accounts/sidebar/AccountsSidebar';
import { FeatureFlagProvider } from '../services/FeatureFlagProvider';
import { useGetAllClientsByGrantTypeQuery } from '../services/clientRegistryApi';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from './appSlice';
import AppHeader from '../header/AppHeader.tsx';

export const App = () => {
    const userLocale = useAppSelector(getLocale);
    const showSessionExpired = useAppSelector(
        state => isUserSessionExpired(state) && !getSessionExpiredAcknowledged(state)
    );

    const dispatch = useAppDispatch();

    // initialize GET for clients here to make data accessible as soon as possible
    useGetAllClientsByGrantTypeQuery('partner_integration');

    return (
        <FeatureFlagProvider>
            <ApplicationLayout>
                <ApplicationLayout.Header>
                    <AppHeader />
                </ApplicationLayout.Header>
                <ApplicationLayout.Sidebar className={'right'}>
                    <AccountsSidebar />
                </ApplicationLayout.Sidebar>
                <ApplicationLayout.Body>
                    <NotificationsContainer />
                    <SessionExpiredDialog
                        locale={userLocale ?? 'en-GB'}
                        onClose={() => dispatch(hideSessionExpiredDialog())}
                        show={showSessionExpired}
                    />
                    <Outlet />
                </ApplicationLayout.Body>
            </ApplicationLayout>
        </FeatureFlagProvider>
    );
};
